import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Input from '../../forms/Input';
import Checkbox from '../../forms/Checkbox';
import FormSetting from '../../layout/FormSetting';
import Button from '../../forms/Button';
import RoleProtected, { userRoles } from '../../RoleProtected';


const Email = ({ ...props }) => {

    return (
        <PageBreak>
            <RoleProtected roles={userRoles.admin}>
                <FormSetting
                    label='Email Settings'
                    name='emailSettings'
                    // controls={[<Button onClick={() => alert('TESTING')}>Test Email</Button>]}

                    getInputs={QuestRoute.settings.email}
                    onSubmit={e => HamQuest.put(QuestRoute.settings.email, e)}
                    text='Update'
                    editable
                    autoComplete='off'
                >

                    <Input
                        label='From Email Address'
                        name='emailAddress'
                    />

                    <Input
                        label='From Email Name'
                        name='emailDisplayName'
                    />

                    {/* <Checkbox
                        label='Use Business Email(Recommended)'
                        name='smtpUseSsl'
                    /> 
                    <Checkbox
                        label='Use Hosted Solutions Email'
                        name='useHSEmail'
                    /> */}

                    <Checkbox
                        label='SMTP Username same as From Email Address'
                        name='smtpUserSameAsFrom'
                    />

                    <Input
                        label='SMTP Username'
                        name='smtpAuthUser'
                    />

                    <Input
                        label='SMTP Password'
                        name='smtpAuthPwd'
                        type='password'
                        autocomplete='off'
                    />

                    <Input
                        label='SMTP Server'
                        name='smtpServer'
                    />

                    <Input
                        label='SMTP Port'
                        name='smtpPort'
                        type='number'
                    />

                    <Checkbox
                        label='Use SSL'
                        name='useSmtp'
                    />

                    <Checkbox
                        label='SMTP Login Required'
                        name='smtpLoginRequired'
                    />

                </FormSetting>
            </RoleProtected>

        </PageBreak >
    );
}

export default Email;